import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Menu.module.css";
import SeperatorBlue from "../SeperatorBlue/SeperatorBlue.module";
const Menu = ({
  receivedData,
  setAddCreditModalOpen,
  setTransactionModalOpen,
  setAutoRenewModalOpen,
  setBatchRenewModalOpen,
  setPricingModalOpen,
  modalOpener,
  onLogout,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className={styles.menu}>
        <div
          className={`${styles.chip} ${styles.status}`}
          onClick={() => navigate("/server-status")}
        >
          <div className={styles.label}>
            <i class="fa-regular fa-server"></i>
            وضعیت سرور
          </div>
        </div>
        <div
          className={`${styles.chip} ${styles.hist}`}
          onClick={() => modalOpener("transaction")}
        >
          <div className={styles.label}>
            <i class="fa-regular fa-clock-rotate-left"></i>
            تاریخچه پرداخت ها
          </div>
        </div>

        <div
          className={`${styles.chip} ${styles.credit}`}
          onClick={() => modalOpener("addCredit")}
        >
          <div className={styles.label}>
            {" "}
            <i class="fa-regular fa-plus-large"></i>
            افزایش اعتبار
          </div>
        </div>

        <div
          className={`${styles.chip} ${styles.renew}`}
          onClick={() => navigate("/account-renew")}
        >
          <div className={styles.label}>
            <i class="fa-regular fa-repeat"></i>
            تمدید اکانت ها
          </div>
        </div>
        <div
          className={`${styles.chip} ${styles.new}`}
          onClick={() => navigate("/new-profile")}
        >
          <div className={styles.label}>
            <i class="fa-regular fa-user-plus"></i>
            پروفایل جدید
          </div>
        </div>
        <div className={`${styles.chip} ${styles.wallet}`}>
          <div className={styles.label}>
            <i class="fa-regular fa-wallet"></i>
            موجودی کیف پول شما:
          </div>
          {receivedData.remainingWallet?.toLocaleString("fa-IR")} تومان
        </div>
        {/* <div className="eachoption" onClick={() => navigate("/new-profile")}>
            <i class="fa-thin fa-user-plus"></i>
            پشتیبانی
          </div> */}
        {/* <div className="eachoption" onClick={() => modalOpener("pricing")}>
            <i class="fa-thin fa-box-open-full"></i>
            مشاهده تعرفه ها
          </div> */}
      </div>
      <SeperatorBlue />
    </>
  );
};

export default Menu;
